const production = process.env.NODE_ENV === 'production';

export const CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL
  || (production ? '/chatbot/' : 'http://localhost:3001');
